module.exports = __webpack_public_path__ + "static/img/s_microneedling.a2c2c09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/s_microneedling.jpg
// module id = 102
// module chunks = 1